import * as actionTypes from "../actionTypes";
import * as userContentKeys from "../enums/userContentKeys";
import createReducer from "../lib/createReducer";
import find from "lodash.find";
import getLibraryIndex from "../lib/getLibraryIndex";

const defaultState = {};

function USERS_SET(state, action) {
	const { user } = action;

	if (!user) {
		return state;
	}

	const key = user.id;
	if (key === undefined || key === null) {
		return state;
	}

	return {
		...state,
		[key]: {
			beta: user.beta,
			content: user.content,
			email: user.email,
			firstName: user.first_name,
			groupAdmin: user.group_admin,
			groupId: user.group_id,
			id: user.id,
			individual: user.individual,
			lastLogin: user.last_login,
			lastName: user.last_name,
			passwordReset: user.password_reset,
			phoneNumber: user.phone_number,
			practiceAreas: user.practice_areas,
			startTime: user.start_time,
			superAdmin: user.super_admin,
			job_role: user.job_role,
		},
	};
}

function USERS_SET_MULTIPLE(state, action) {
	const { users } = action;
	if (!users) {
		return state;
	}

	let nextState = state;
	users.forEach(user => {
		nextState = USERS_SET(nextState, { user });
	});

	return nextState;
}

function USERS_REMOVE(state, action) {
	const { removedIds } = action;
	if (!removedIds) {
		return state;
	}

	const nextState = { ...state };
	removedIds.forEach(id => {
		delete nextState[id];
	});

	return nextState;
}

function USERS_TOGGLE_PRACTICE_AREA_FIELD(state, action) {
	const { libraryName, userId, toggled, toggleField } = action;

	const user = state[userId];
	const index = getLibraryIndex(user ? user.practiceAreas : [], libraryName);
	if (index === -1) {
		return state;
	}
	const practiceAreas = [...user.practiceAreas];
	practiceAreas[index] = {
		...practiceAreas[index],
		[toggleField]: toggled,
	};

	const nextState = {
		...state,
		[userId]: { ...user, practiceAreas },
	};
	return nextState;
}

function USERS_UPDATE_PERSONAL_INFO(state, action) {
	const { userId, firstName, lastName, phoneNumber, startTargetName, jobRole } = action;
	if (
		userId === null ||
		userId === undefined ||
		firstName === null ||
		firstName === undefined ||
		lastName === null ||
		lastName === undefined ||
		jobRole === null ||
		jobRole === undefined
	) {
		return state;
	}

	const user = state[userId];
	const nextState = {
		...state,
		[userId]: {
			...user,
			firstName,
			lastName,
			phoneNumber,
			content: {
				...user.content,
				[userContentKeys.DEFAULT_START_TARGET]: startTargetName,
			},
			job_role: jobRole
		},
	};
	return nextState;
}

function USERS_SET_ACTIVE_LIBRARIES(state, action) {
	const { libraryNames, userId, turnOnDocketReport } = action;
	if (
		!libraryNames ||
		userId === null ||
		userId === undefined ||
		!state[userId] ||
		!state[userId].practiceAreas
	) {
		return state;
	}

	const user = state[userId];
	const practiceAreas = user.practiceAreas.map(pa => {
		const nextActive = libraryNames.length
			? !!find(libraryNames, libName => libName === pa.name)
			: false;
		if (pa.active === nextActive) {
			return pa;
		}
		let nextDocketReport = pa.docket_report;
		if (nextActive && turnOnDocketReport) {
			nextDocketReport = true;
		}
		return {
			...pa,
			active: nextActive,
			docket_report: nextDocketReport,
		};
	});

	return {
		...state,
		[userId]: {
			...user,
			practiceAreas,
		},
	};
}

function USERS_ACTIVATEE_LIBRARIES(state, action) {
	const { libraryNames, userId } = action;
	if (
		!libraryNames ||
		userId === null ||
		userId === undefined ||
		!state[userId] ||
		!state[userId].practiceAreas
	) {
		return state;
	}

	const user = state[userId];
	let practiceAreaAdded = false;
	const practiceAreas = user.practiceAreas.map(pa => {
		const nextActive = !!find(libraryNames, libName => libName === pa.name);
		if (!nextActive || pa.active) {
			return pa;
		}
		practiceAreaAdded = true;
		return {
			...pa,
			active: true,
			docket_report: true,
		};
	});

	if (!practiceAreaAdded) {
		return state;
	}

	return {
		...state,
		[userId]: {
			...user,
			practiceAreas,
		},
	};
}

const handlers = {};
handlers[actionTypes.USERS_SET] = USERS_SET;
handlers[actionTypes.USERS_SET_MULTIPLE] = USERS_SET_MULTIPLE;
handlers[actionTypes.USERS_REMOVE] = USERS_REMOVE;
handlers[actionTypes.USERS_UPDATE_PERSONAL_INFO] = USERS_UPDATE_PERSONAL_INFO;
handlers[actionTypes.USERS_SET_ACTIVE_LIBRARIES] = USERS_SET_ACTIVE_LIBRARIES;
handlers[actionTypes.USERS_ACTIVATE_LIBRARIES] = USERS_ACTIVATEE_LIBRARIES;
handlers[actionTypes.USERS_TOGGLE_PRACTICE_AREA_FIELD] = USERS_TOGGLE_PRACTICE_AREA_FIELD;

export default createReducer(defaultState, handlers);
